module.exports = __webpack_public_path__ + "img/nodeJs.ee9d8a6c.svg";